module.exports = __webpack_public_path__ + "static/img/astronaut.a4665fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/notfound/image/astronaut.svg
// module id = kSIN
// module chunks = 39